<template>
  <div class="">
    <ul class="list-group mg-b-0 tx-13">
      <li class="list-group-item  ">
        <span class="tx-rubik tx-bold">{{ obj.data.task.task }}</span> сургалт
        нь

        <span class="tx-rubik tx-bold">{{
          obj.data.task.dueStartDate | moment("YYYY.MM.DD HH:mm")
        }}</span>
        өдрөөс
        <span class="tx-rubik tx-bold">{{
          obj.data.task.dueDate | moment("YYYY.MM.DD HH:mm")
        }}</span>
        хүртэл, нийт
        <span class="tx-rubik tx-bold">{{ diffDays() }}</span> өдрийн
        хугацаанд

        <template v-if="obj.data.task.flag == 9">
          идэвхтэй байх ба, суралцагч тус бүр сургалтад элссэн өдрөөс эхлэн
          <span class="tx-rubik tx-bold">{{ obj.data.task.i2 }}</span> хоногийн
          туршид сургалтыг үзэх,
        </template>
      </li>

      <li class="list-group-item d-flex justify-content-between">
        <span class="tx-medium">Хэрэглэгчийн хүсэлтээр бүртгэх эсэх</span>
        <span class="tx-rubik tx-bold">{{
          obj.data.task.minutes == 1 ? "Тийм" : "Үгүй"
        }}</span>
      </li>
      <template v-if="obj.data.task.minutes == 1">
        <li class="list-group-item d-flex justify-content-between">
          <span class="tx-medium">Анги дүүргэлт</span>
          <span class="tx-rubik tx-bold">{{ obj.data.task.i3 }}</span>
        </li>
        <li class="list-group-item d-flex justify-content-between">
          <span class="tx-medium">Бүртгэлийн хугацаа</span>
          <span class="tx-rubik tx-bold"
            >{{ obj.data.task.d3 | moment("YYYY.MM.DD HH:mm") }} -
            {{ obj.data.task.d4 | moment("YYYY.MM.DD HH:mm") }}</span
          >
        </li>
      </template>
      <li class="list-group-item d-flex justify-content-between">
        <span class="tx-medium">Сертификат олгох эсэх</span>
        <span class="tx-rubik tx-bold">{{
          obj.data.task.i6 == 1 ? "Тийм" : "Үгүй"
        }}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between">
        <span class="tx-medium">Төлбөртэй эсэх</span>
        <span class="tx-rubik tx-bold">{{
          obj.data.task.qualityPercChanar == 1 ? "Тийм" : "Үгүй"
        }}</span>
      </li>
      <li
        v-if="obj.data.task.qualityPercChanar == 1"
        class="list-group-item d-flex justify-content-between"
      >
        <span class="tx-medium">Төлбөрийн хэмжээ</span>
        <span class="tx-rubik tx-bold">{{ obj.data.task.budget }}</span>
      </li>
      <!-- <li class="list-group-item d-flex justify-content-right">
        <span class="tx-medium">тохиргоогоор нийтлэх гэж байна.</span>
      </li> -->
    </ul>
  </div>
</template>

<script>
import videoConference from "@/components/modules/videoConference";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";

import "element-ui/lib/theme-chalk/index.css";
import { DatePicker, Notification } from "element-ui";
import { mapActions } from "vuex";

const moment = require("moment");

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    videoConference,
    DatePicker,
    Notification,
    dzInfo: () => ({
      component: import("@/components/task/detail/ot/599.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
    boxId: {
      type: Number,
      default: () => 0,
    },
    parentTask: {
      type: Object,
      default: () => {},
    },
    fields: {
      type: Array,
      default: () => [],
    },
    loaded: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      activationObj: {
        flag: -1,
        key: "",
        code: "",
        loading: false,
      },
      bookInfo: {
        data: {},
        rdy: false,
      },
      googleMapMaker: [],
      googleMapRdy: false,
    };
  },
  mounted() {
    if (this.obj.data.task.objectTypeId == 138) {
      this.initActivation();
    }
    if (this.obj.data.task.objectTypeId == 504) {
      this.getBookUldegdel();
    }

    if (this.obj.data.task.lat != null && this.obj.data.task.lng != null) {
      this.googleMapMaker = [
        {
          position: {
            lat: parseFloat(this.obj.data.task.lat),
            lng: parseFloat(this.obj.data.task.lng),
          },
        },
      ];
      this.$nextTick(() => {
        this.googleMapRdy = true;
      });
    }
  },
  methods: {
    diffDays() {
      var a = moment(this.obj.data.task.dueDate);
      var b = moment(this.obj.data.task.dueStartDate);
      //a.diff(b, 'days') // 1
      return a.diff(b, "days");
    },
    ...mapActions(["handleLoading"]),
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    createPackageInvoiceEbarimt() {
      this.handleLoading({ isLoading: true });
      request({
        data: { id: this.obj.data.task.id },
        api: { url: "EBarimt/CreatePackInvoiceBill", method: "post" },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          Notification.success({
            title: "Амжилттай",
            message: `И-баримт амжилттай шивэгдлээ.`,
            duration: 10000,
            position: "bottom-left",
          });

          this.$emit("on-reload", {mode: 0, obj: {id: this.obj.data.task.id}});
        }
      });
    },
    payByCash() {
      var desc = prompt("Тайлбар оруулна уу", "");
      if (desc != null) {
        let link = "Payment/payByCash";
        if (this.obj.data.task.objectTypeId == 532)
          link = "Payment/PayPackageInvoiceByCash";
        request({
          data: { invoiceId: this.obj.data.task.id, desc: desc },
          api: { url: link, method: "post" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.$emit("on-task-field-set-local", {
              fieldName: "isTender",
              value: true,
            });
            //this.obj.data.task.isTender = true;
          }
        });
      }
    },
    // TODO: tolbor oruulj irsen uyed hiih
    // checkInvoice() {
    //   this.paymentVisible = true;
    // },
    forceActivation() {
      request({
        data: {
          key: this.activationObj.key,
          groupId: this.obj.data.task.groupId,
          userId: this.obj.data.task.userId,
        },
        api: { url: "user/activate", method: "post" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.initActivation();
        }
      });
    },
    initActivation() {
      this.activationObj.loading = true;
      request({
        data: { userId: this.obj.data.task.userId },
        api: { url: "auth/CheckActivation", method: "post" },
        store: this.$store,
      }).then((res) => {
        this.activationObj.loading = false;
        if (res != false) {
          if (res.data.flag == -900) {
            this.activationObj.flag = res.data.flag;
            this.activationObj.code = res.data.key;
          } else {
            this.activationObj.flag = res.data.flag;
          }
        }
      });
    },
    getBookUldegdel() {
      request({
        params: {
          id: this.obj.data.task.organizationTaskId,
        },
        api: { url: "library/BookDetail", method: "GET" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.bookInfo.data = res.data.book;
          this.bookInfo.rdy = true;
          if (this.obj.data.task.i1 == 0) {
            this.obj.data.task.d3 = moment(new Date(), "DD-MM-YYYY")
              .add(3, "days")
              .format("YYYY-MM-DD");
          }
        }
      });
    },
    bookCmd(mode) {
      if (mode == 1) {
        request({
          data: {
            id: this.obj.data.task.id,
            date: this.obj.data.task.d3,
          },
          api: { url: "library/AcceptOrder", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      } else if (mode == -1) {
        request({
          data: {
            id: this.obj.data.task.id,
          },
          api: { url: "library/DeclineOrder", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      } else if (mode == 0) {
        request({
          data: {
            id: this.obj.data.task.id,
          },
          api: { url: "library/GiveBackTheBook", method: "POST" },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            this.bookCmdAfter(res);
          }
        });
      }
    },
    bookCmdAfter(res) {
      this.$emit("on-reload", this.obj.data.task);
      Notification.info({
        message: res.msg,
        duration: 30000,
        type: "info",
        position: "top-right",
        offset: 50,
      });
    },
  },
};
</script>
